import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { ProductDetailDescription } from "./ProductDetailDescription.js";
import { isSolutionsVariant } from "../../../../../../types/types/typeguards.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
const ProductDetailDescriptionContainer = ({
  className,
  children
}) => {
  const { getLabel } = useIntl();
  const { activeVariant } = useProductData();
  const { description, shortDescription, variantUsps } = activeVariant;
  let title;
  let header = shortDescription;
  if (isSolutionsVariant(activeVariant)) {
    title = shortDescription || getLabel("products.solutions.header.header");
    header = void 0;
  }
  return /* @__PURE__ */ React.createElement(
    ProductDetailDescription,
    {
      className,
      title,
      header,
      description,
      usps: variantUsps,
      children
    }
  );
};
export {
  ProductDetailDescriptionContainer
};
//# sourceMappingURL=ProductDetailDescriptionContainer.js.map
